import { SvgIcon } from '@mui/material';

export function SupportIcon(props) {
	return (
		<SvgIcon
			width="28"
			height="28"
			viewBox="0 0 28 28"
			fill="none"
			{...props}
		>
			<path
				d="M14.0002 25.8913V24.1413H21.8078C21.9126 24.1413 21.9986 24.1076 22.0659 24.0404C22.1332 23.9731 22.1668 23.887 22.1668 23.7822V22.7503H18.0386V14.4938H22.1668V12.8337C22.1668 10.5781 21.3696 8.6531 19.7752 7.05866C18.1807 5.46421 16.2557 4.66699 14.0002 4.66699C11.7446 4.66699 9.81961 5.46421 8.22516 7.05866C6.63072 8.6531 5.8335 10.5781 5.8335 12.8337V14.4938H9.96175V22.7503H6.19254C5.60318 22.7503 5.10433 22.5462 4.696 22.1378C4.28766 21.7295 4.0835 21.2306 4.0835 20.6413V12.8337C4.0835 11.4696 4.34376 10.1863 4.86429 8.98366C5.38482 7.78102 6.09532 6.72956 6.99579 5.82928C7.89607 4.92881 8.94752 4.21831 10.1502 3.69778C11.3528 3.17726 12.6361 2.91699 14.0002 2.91699C15.3642 2.91699 16.6475 3.17726 17.8502 3.69778C19.0528 4.21831 20.1043 4.92881 21.0045 5.82928C21.905 6.72956 22.6155 7.78102 23.136 8.98366C23.6566 10.1863 23.9168 11.4696 23.9168 12.8337V23.7822C23.9168 24.3716 23.7127 24.8705 23.3043 25.2788C22.896 25.6871 22.3971 25.8913 21.8078 25.8913H14.0002ZM6.19254 21.0003H8.21175V16.2438H5.8335V20.6413C5.8335 20.7461 5.86714 20.8321 5.93441 20.8994C6.00169 20.9667 6.08773 21.0003 6.19254 21.0003ZM19.7886 21.0003H22.1668V16.2438H19.7886V21.0003ZM6.19254 16.2438H5.8335H8.21175H6.19254Z"
				fill="currentColor"
			/>
		</SvgIcon>
	);
}
